<template>
    <BaseWidget :title="widget.title" :title-url="widget.titleUrl">
        <AppButton :href="widget.titleUrl" desired-action> {{ widget.content.text }} </AppButton>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    name: 'QuestionReviewsWidget',
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    components: {
        AppButton,
        BaseWidget,
    },
};
</script>
